import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Sidebar from './Sidebar';
import useGuideStore from '../../store/useGuideStore';

const SIDEBAR_WIDTH = 0;

// ─── Inner component that triggers guide fetch when activeGuideId changes ─────

function GuideLoader() {
    const { index, activeGuideId } = useGuideStore();

    if (!activeGuideId) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    color: 'text.secondary',
                }}
            >
                <Typography
                    sx={{
                        fontFamily: '"IBM Plex Mono", monospace',
                        fontSize: '0.75rem',
                        letterSpacing: '0.1em',
                        textTransform: 'uppercase',
                    }}
                >
                    Select a guide to begin
                </Typography>
            </Box>
        );
    }

    const entry = index.find((e) => e.id === activeGuideId);
    if (!entry) return null;

    return (
        <iframe
            key={entry.file}
            src={`/guides/${entry.file}`}
            style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
            title={entry.title}
        />
    );
}

// ─── AppShell ─────────────────────────────────────────────────────────────────

export default function AppShell() {
  return (
      <>
        <Sidebar />
        <Box sx={{ display: 'flex', minHeight: '100vh', backgroundColor: 'background.default'}}>

      {/* Main content area */}
      <Box
        component="main"
        sx={{
          flex: 1,
          ml: `${SIDEBAR_WIDTH}px`,
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
          <Box
              sx={{
                  flex: 1,
                  minHeight: '100vh',
                  overflow: 'hidden',
              }}
          >
              <GuideLoader />
          </Box>
      </Box>
    </Box>
      </>
  );
}
